import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AnyePote2 from './icons/AnyePote2';
import AnyeMosca2 from './icons/AnyeMosca2';
import AnyeMosquito2 from './icons/AnyeMosquito2';
import AnyeVistasBarco1 from './icons/AnyeVistasBarco1';
import AnyeVistasBarco3 from './icons/AnyeVistasBarco3';
import AnyeVistasBarco4 from './icons/AnyeVistasBarco4';
import VisitorRegistrationIcon from './icons/VisitorRegistrationIcon';
import AnyeCandado from './icons/AnyeCandado';
import AnyeGrillete from './icons/AnyeGrillete';
import AnyeEsposas from './icons/AnyeEsposas';
import AnyeAzucar from './icons/AnyeAzucar';
import BarcoVolteado from './icons/BarcoVolteado';

const LANGUAGES = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
];

const links = [
  { to: '/Introduccion', icon: BarcoVolteado, label: 'nav.introduccion', divider: true },
  { to: '/Museo1', icon: AnyeVistasBarco1, label: 'nav.museo1' },
  { to: '/Museo2', icon: AnyeVistasBarco3, label: 'nav.museo2', divider: true, subItem: true },
  { to: '/Gispert1', icon: AnyeEsposas, label: 'nav.gispert1' },
  { to: '/Gispert2', icon: AnyePote2, label: 'nav.gispert2', subItem: true },
  { to: '/Gispert3', icon: AnyeGrillete, label: 'nav.gispert3', subItem: true },
  { to: '/Gispert4', icon: AnyeVistasBarco4, label: 'nav.gispert4', subItem: true },
  { to: '/Gispert5', icon: AnyeMosquito2, label: 'nav.gispert5', subItem: true },
  { to: '/Gispert6', icon: AnyeMosca2, label: 'nav.gispert6', divider: true, subItem: true },
  { to: '/Instructivo', icon: AnyeCandado, label: 'nav.instructivo' },
  { to: '/VisitorRegistration', icon: VisitorRegistrationIcon, label: 'nav.newsletter' },
];

const NavVertical = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const navRef = useRef(null);
  const langRef = useRef(null);
  const location = useLocation();

  // Close menus on route change
  useEffect(() => {
    setIsOpen(false);
    setLangOpen(false);
  }, [location.pathname]);

  // Cerrar menú al clicar fuera; cerrar dropdown de idioma al clicar fuera
  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setIsOpen(false);
      }
      if (langRef.current && !langRef.current.contains(e.target)) {
        setLangOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div ref={navRef} className={`NavVertical${isOpen ? ' NavVertical--open' : ''}`}>
      <div className="NavVertical-top">
        <button
          type="button"
          className="NavVertical-toggle"
          onClick={() => setIsOpen((o) => !o)}
          aria-expanded={isOpen}
          aria-label={isOpen ? t('nav.closeMenu') : t('nav.openMenu')}
        >
          <span className="NavVertical-iconWrapper">
            <AnyeAzucar />
          </span>
        </button>

        {/* Custom language picker */}
        <div className="NavVertical-lang" ref={langRef}>
          <button
            type="button"
            className="NavVertical-langBtn"
            onClick={() => setLangOpen((o) => !o)}
            aria-expanded={langOpen}
            aria-label="Select language"
          >
            {currentLang.label}
            <span className="NavVertical-langArrow" />
          </button>
          <div className={`NavVertical-langDrop${langOpen ? ' NavVertical-langDrop--open' : ''}`}>
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                type="button"
                className={`NavVertical-langOpt${lang.code === i18n.language ? ' NavVertical-langOpt--active' : ''}`}
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  setLangOpen(false);
                }}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="NavVertical-list">
        <Link to="/" className="NavVertical-link NavVertical-link--home" style={{ animationDelay: '0.04s' }} onClick={() => setIsOpen(false)}>
          <span className="NavVertical-textWrapper">{t('nav.home')}</span>
        </Link>
        <div className="NavVertical-divider" style={{ animationDelay: '0.05s' }} />
        {links.map(({ to, icon: Icon, label, divider, subItem }, index) => (
          <React.Fragment key={to}>
            <Link
              to={to}
              className={`NavVertical-link${subItem ? ' NavVertical-link--sub' : ''}`}
              style={{ animationDelay: `${0.04 + (index + 1) * 0.03}s` }}
              onClick={() => setIsOpen(false)}
            >
              <span className="NavVertical-iconWrapper">
                <Icon />
              </span>
              <span className="NavVertical-textWrapper">{t(label)}</span>
            </Link>
            {divider && (
              <div
                className="NavVertical-divider"
                style={{ animationDelay: `${0.04 + (index + 1) * 0.03}s` }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default NavVertical;
